import { Location } from '@angular/common';
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  allowedImageFormats,
  getRandomInteger,
  isLargeScreen,
  uploadedFileCheck,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { AddEditClientComponent } from '../../../../shared/components/add-edit-client/add-edit-client.component';
import { AddEditSiteComponent } from '../../../../shared/components/add-edit-site/add-edit-site.component';
import { ClientSiteContactsComponent } from '../../../../shared/components/client-site-contacts/client-site-contacts.component';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ContactComponent } from '../../../../shared/components/contact/contact.component';
import { EventSchedulerComponent } from '../../../../shared/components/event-scheduler/event-scheduler.component';
import { MediaPreviewComponent } from '../../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { ClientsService } from '../../clients/clients.service';
import { companyTableDetails } from '../../tableDetails';
import { firstValueFrom, Subscription } from 'rxjs';
import { SelectSubBillerComponent } from '../../../../shared/components/select-sub-biller/select-sub-biller.component';
import { SelectMonitoringCompanyComponent } from '../../../../shared/components/select-monitoring-company/select-monitoring-company.component';
@Component({
  selector: 'gtapp-view-site',
  templateUrl: './view-site.component.html',
  styleUrl: './view-site.component.scss',
  standalone: false,
})
export class ViewSiteComponent implements OnInit, OnDestroy {
  siteDetailData: any;
  isAdmin = this.dataCheckService.isUserAdmin();
  isDispatchUser = this.dataCheckService.isDispatchUser();

  selectedSiteFiles: any = [];
  siteHistory: any = [];

  siteId: any;

  dialogRef: any;

  fileUploadError: any;
  fileDescription: any;
  uploadFile: any;

  siteContactListTemp: any = [];
  newInfromation: any;

  mapLatLong: any;
  siteReportUsers: any = [];

  slicedSiteReportUsers: any = [];
  slicedSelectedSiteFiles: any = [];

  patrolReportSchedules: any = [];

  userEventDetailsTableView = companyTableDetails?.desktopTable;
  selectedEvent: any;
  largeView: Boolean = isLargeScreen;

  clientLookupDataList: any = [];
  initialClientDataList: any = [];

  selectedClient: any;
  selectedClientName: any;
  routerSubscription!: Subscription;
  constructor(
    private dialogService: ModalDialogueService,
    private clientService: ClientsService,
    private spinnerService: LoadingSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
    private dataCheckService: DataCheckService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
  ) {
    // WHEN USER CLICK THE BACK BUTTON
    this.routerSubscription = this.router.events.subscribe((event: any) => {
      if (event.navigationTrigger === 'popstate') {
        this.dialogRef?.close();
      }
    });
    this.siteId = this.route.snapshot.paramMap.get('sKey');
    this.getSiteDetailById();
    const routeFragment: any = this.route.snapshot.fragment;
    if (['jc', 'pc'].includes(routeFragment)) {
      this.scrollToReportSection(`#${routeFragment}`);
    }
  }
  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
    this.appService.removeToolTips();
  }

  ngOnInit(): void {}
  scrollToReportSection(containerId: any) {
    setTimeout(() => {
      const idElement = document.querySelector(containerId);

      if (idElement) {
        idElement?.scrollIntoView();
      }
    }, 200);
  }
  getSiteHistoryData() {
    this.clientService
      .getSiteDetailsById(this.siteId, { get_history: 1 })
      .subscribe((response: any) => {
        this.siteHistory = response?.data || [];
      });
  }

  getSiteDetailById() {
    this.spinnerService.show();
    this.clientService
      .getSiteDetailsById(this.siteId)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
        }
        this.spinnerService.hide();
      });
  }
  formatSiteData(response: any) {
    this.appService.initializeBootstrapTooltips();

    this.selectedClient = null;
    this.siteDetailData = response?.data;
    this.siteContactListTemp = this.siteDetailData?.contacts || [];
    let gpscoords = {
      lat: this.siteDetailData?.address?.latitude,
      lon: this.siteDetailData?.address?.longitude,
    };
    this.mapLatLong = gpscoords;

    this.selectedSiteFiles = this.siteDetailData?.site_files || [];
    this.slicedSelectedSiteFiles = this.selectedSiteFiles?.slice(0, 3);

    this.siteReportUsers = this.siteDetailData?.report_users || [];
    this.slicedSiteReportUsers = this.siteReportUsers?.slice(0, 3);
    this.patrolReportSchedules =
      this.siteDetailData?.patrol_report_schedules || [];
    if (this.isAdmin && this.largeView) this.getSiteHistoryData();
  }

  openSiteLocationContactTemplate() {
    if (this.isAdmin || this.isDispatchUser) {
      this.dialogRef = this.dialogService.open(ClientSiteContactsComponent, {
        data: {
          siteData: this.siteDetailData,

          selectedUsers: this.siteDetailData?.contacts,
          contactType: 'lc',
        },
      });
      this.dialogRef.afterClosed().subscribe((value: any) => {
        if (value?.data?.id) {
          this.formatSiteData(value);
        } else {
          this.getSiteDetailById();
        }

        this.spinnerService.hide();
      });
    }
  }
  onTableRowClick(event: any) {
    this.selectedEvent = event;
  }

  getSiteContacts() {
    this.spinnerService.show();
    this.clientService
      .getSiteContacts(this.siteDetailData?.id)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.siteContactListTemp = response['data'];
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  primaryContact(contact: any) {
    this.clientService
      .editLocationContact(contact?.id)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
          this.getSiteContacts();
        }
      });
  }

  editSite(site: any, editSiteName = true) {
    if (this.isAdmin || this.isDispatchUser) {
      const addSiteDialogRef = this.dialogService.open(AddEditSiteComponent, {
        data: { detailData: site, editSite: true, editSiteName: editSiteName },
      });
      addSiteDialogRef.afterClosed().subscribe((value) => {
        if (value !== 'close') {
          if (value?.id) {
            this.formatSiteData({ data: value });
          } else {
            this.getSiteDetailById();
          }
        }
      });
    }
  }
  openJobView() {
    if (this.siteDetailData?.site_stats?.job_exists) {
      this.router.navigate(['/jobs', { siteId: this.siteId }]);
    } else {
      this.router.navigate(['/add-job']);
    }

    sessionStorage.setItem(
      'fromSite',
      JSON.stringify({
        site: {
          id: this.siteId,
          company_name: this.siteDetailData?.company_name,
        },
        client: {
          id: this.siteDetailData?.company?.id,
          company_name: this.siteDetailData?.company?.company_name,
        },
      }),
    );
  }
  openCPView() {
    if (this.siteDetailData?.site_stats?.checkpoint_exists) {
      this.router.navigate(['/checkpoints', { siteId: this.siteId }]);
    } else {
      this.router.navigate(['/add-checkpoint']);
    }
    sessionStorage.setItem(
      'fromSite',
      JSON.stringify({
        site: {
          id: this.siteId,
          company_name: this.siteDetailData?.company_name,
        },
        client: {
          id: this.siteDetailData?.company?.id,
          company_name: this.siteDetailData?.company?.company_name,
        },
      }),
    );
  }
  openReportView() {
    sessionStorage.setItem('selectedTab', 'Scheduled Reports');
    this.router.navigate(['/reports'], {
      queryParams: {
        siteInfo: btoa(
          JSON.stringify({
            id: this.siteId,
            company_name: this.siteDetailData?.company_name,
            company: {
              id: this.siteDetailData?.company?.id,
              company_name: this.siteDetailData?.company?.company_name,
            },
          }),
        ),
      },
    });
  }
  openEventLog() {
    this.router.navigate(['/user-events'], {
      fragment: btoa(
        JSON.stringify({
          selectedSite: this.siteDetailData,
        }),
      ),
    });
  }
  redirectToClientPage() {
    this.router.navigate([
      '/view-client',
      { cKey: String(this.siteDetailData?.company?.id) },
    ]);
  }

  openJobReportContactTemplate() {
    if (this.isAdmin || this.isDispatchUser) {
      const dialogRef = this.dialogService.open(ClientSiteContactsComponent, {
        data: {
          siteData: this.siteDetailData,
          selectedUsers: JSON.parse(
            JSON.stringify(this.siteDetailData?.report_users || []),
          ),
        },
      });
      dialogRef.afterClosed().subscribe((res: any) => {
        if (res?.data?.id) {
          this.formatSiteData(res);
        } else {
          this.getSiteDetailById();
        }
      });
    }
  }

  openSiteContactTemplate(data: any, siteData: any, contactType: any) {
    this.dialogRef = this.dialogService.open(ContactComponent, {
      data: {
        contactData: data,

        siteData: siteData,
        contactType: contactType,
      },
    });
    this.dialogRef.afterClosed().subscribe((dialogResponse: any) => {
      if (dialogResponse !== false) {
        this.getSiteDetailById();
      }
    });
  }

  openInformationTemplate(template: any) {
    this.newInfromation = this.siteDetailData?.information;

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: { siteInfo: true },
      },
      this.viewContainerRef,
    );
  }
  openManagerInfoTemplate(template: any) {
    this.newInfromation = this.siteDetailData?.manager_notes;
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  openFileUploadTemplate(template: any) {
    this.fileUploadError = null;
    this.fileDescription = null;
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }

  async handleFileInput(event: any) {
    let file = event?.target?.files.item(0);

    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    this.fileUploadError = await uploadedFileCheck(
      fileExtension,
      fileSize,
      1024 * 1024 * 8,
      ['pdf', ...allowedImageFormats],
    );
    if (!this.fileUploadError) {
      this.uploadFile = event?.target?.files.item(0);
    }
  }

  onUploadFile() {
    if (this.uploadFile) {
      this.spinnerService.show();
      let fileData: FormData = new FormData();
      fileData.append('file', this.uploadFile);
      fileData.append('upload_files', '1');
      fileData.append('description', this.fileDescription);

      this.appService
        .formDataApi(`site/${this.siteDetailData?.id}/update`, fileData)
        .then((response: any) => {
          if (response?.status == 'success') {
            this.formatSiteData(response);
            this.fileUploadError = null;
            this.fileDescription = null;
            this.uploadFile = null;
            this.spinnerService.hide();
          } else {
            this.fileUploadError = null;
            this.fileDescription = null;
            this.uploadFile = null;
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response?.message,
            });
          }
        });
    }
  }
  onOpenFile(file: any) {
    if (file?.extension === '.pdf') {
      this.downloadFile(file);
    } else {
      this.dialogRef = this.dialogService.open(
        MediaPreviewComponent,
        {
          data: { mediaSrc: file?.file_url },
        },
        this.viewContainerRef,
      );
    }
  }
  openSchedulerTemplate(schedule?: any) {
    this.dialogRef = this.dialogService.open(EventSchedulerComponent, {
      data: { siteData: this.siteDetailData, scheduleData: schedule },
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        this.formatSiteData(value);
      }
    });
  }

  downloadFile(file: any) {
    const a = document.createElement('a');
    a.href = file?.file_url;
    a.download = `${file?.name}${file?.extension}`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  deleteSiteFile(file: any) {
    this.clientService
      .updateSite(this.siteDetailData?.id, {
        file_id: file?.id,
        delete_file: 1,
      })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }

  deleteFile(file: any) {
    let dialogMsg = `Permanently delete file: ${file.description}`;
    this.dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Delete File`,
        message: dialogMsg,
      },
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();

        this.deleteSiteFile(file);
      }
    });
  }

  updateSiteInformation() {
    this.spinnerService.show();
    this.clientService
      .updateSite(
        this.siteDetailData?.id,
        {
          information: this.newInfromation,
        },
        { update_information: 1 },
      )
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }
  shiftFocus(elementId: string, time?: number) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.focus();
    }, time);
  }

  updateSiteManagerNotes() {
    this.spinnerService.show();
    this.clientService
      .updateSite(
        this.siteDetailData?.id,
        {
          manager_notes: this.newInfromation,
        },
        { update_manager_notes: 1 },
      )
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }

  selectFile() {
    var button: any = document.getElementById('fileInput');
    button.click();
  }
  deleteSite(site: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Delete Site`,
        message: `Checkpoints belonging to deleted sites will no longer be available.`,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.spinnerService.show();
        this.clientService
          .enableDisableSiteById(site?.id)
          .then((response: any) => {
            if (response?.status == 'success') {
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
              this.router.navigate(['/sites']);
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
            this.spinnerService.hide();
          });
      }
    });
  }
  onFocus(inputType: string, index: number) {
    const keyInput = document.getElementById(`Key${index}`);
    const descriptionInput = document.getElementById(`Description${index}`);

    if (inputType === 'Key') {
      keyInput?.classList.add('focused');
      descriptionInput?.classList.remove('focused');
    } else {
      descriptionInput?.classList.add('focused');
      keyInput?.classList.remove('focused');
    }
  }

  onBlur(inputType: string, index: number) {
    const keyInput = document.getElementById(`Key${index}`);
    const descriptionInput = document.getElementById(`Description${index}`);

    keyInput?.classList.remove('focused');
    descriptionInput?.classList.remove('focused');
  }
  reportSendApproval() {
    this.spinnerService.show();
    this.clientService
      .updateSite(this.siteDetailData?.id, {}, { send_report_approval: 1 })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }
  openSiteClientChangeTemplate(template: any) {
    this.onClientSearch('');
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: { randomNumber: getRandomInteger(1000, 9999) },
      },
      this.viewContainerRef,
    );
  }

  onClientSearch(event: any) {
    this.selectedClientName = event ? event.target.value : '';
    this.clientService
      .searchClients(this.selectedClientName)
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.clientLookupDataList = res?.data?.filter(
            (client: any) => client?.id !== this.siteDetailData?.company?.id,
          );
          if (!event) {
            this.initialClientDataList = JSON.parse(
              JSON.stringify(this.clientLookupDataList),
            );
          }
        }
      });
  }
  onClientSelect(data: any) {
    if (data?.key === 0) {
      this.openAddCustomerForm();
    }
    if (data?.id) {
      this.selectedClient = data;
    }
  }
  editField(field: string) {
    this.selectedClient = null;
    this.shiftFocus('clientId');

    setTimeout(() => {
      this.clientLookupDataList = JSON.parse(
        JSON.stringify(this.initialClientDataList || []),
      );
    }, 200);
  }
  openAddCustomerForm() {
    const dialogref = this.dialogService.open(AddEditClientComponent, {
      data: {
        companyData: {
          company_name: this.selectedClientName,
        },
      },
    });

    dialogref.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        this.onClientSelect(value?.data);
      }
    });
  }
  updateSiteClient() {
    this.spinnerService.show('Reassigning Site Client');
    this.clientService
      .updateSite(
        this.siteDetailData?.id,
        {
          company_id: this.selectedClient?.id,
        },
        { reassign_company: 1 },
      )
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }
  openCamPopup() {
    var button: any = document.getElementById('siteLogoInput');
    button.click();
  }

  async handleSiteLogoInput(item: any) {
    let file = item.files.item(0);
    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    let fileCheckError = await uploadedFileCheck(fileExtension, fileSize);
    if (fileCheckError) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: fileCheckError,
      });
    } else {
      this.onFileSubmit(item.files.item(0));
    }
  }
  onFileSubmit(file: any) {
    if (file) {
      this.spinnerService.show();
      let fileData: FormData = new FormData();
      fileData.append('file', file);
      fileData.append('upload_logo', '1');

      this.appService
        .formDataApi(`site/${this.siteDetailData?.id}/update`, fileData)
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.formatSiteData(response);
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
          this.spinnerService.hide();
        });
    }
  }
  removeSiteLogo() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Remove Logo`,
        message: '',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();

        this.clientService
          .updateSite(this.siteDetailData?.id, {
            remove_logo: 1,
          })
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.formatSiteData(response);
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
            this.spinnerService.hide();
          });
      }
    });
  }
  updateProrityMessage(message: string) {
    this.spinnerService.show('Updating Changes');
    this.clientService
      .updateSite(
        this.siteDetailData?.id,
        {
          priority_notes: message,
        },
        { update_priority_notes: 1 },
      )
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
          this.spinnerService.hide();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
          this.spinnerService.hide();
        }
      });
  }
  async openTemplate(template: any, event?: any) {
    if (event) {
      const checked = event.target.checked;
      if (!checked) {
        const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
          data: {
            title: `Priority Alarm Response Site`,
            message: 'Remove message?',
          },
        });
        const res = await firstValueFrom(dialogRef.afterClosed());
        if (!res) {
          if (event)
            event.target.checked =
              !!this.siteDetailData?.additional_info?.priority_info?.notes;
          return;
        }
        this.updateProrityMessage('');
        return;
      }
    }

    const dialogRef = this.dialogService.open(
      template,
      {
        data: {
          newValue:
            this.siteDetailData?.additional_info?.priority_info?.notes ||
            this.siteDetailData?.additional_info?.priority_info?.backup_notes,
          oldValue: this.siteDetailData?.additional_info?.priority_info?.notes,
        },
      },
      this.viewContainerRef,
    );
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (!res) {
      if (event)
        event.target.checked =
          !!this.siteDetailData?.additional_info?.priority_info?.notes;
      return;
    }
    this.updateProrityMessage(res?.newValue);
  }
  async openSubBillerTemplate() {
    const dialogRef = this.dialogService.open(SelectSubBillerComponent, {
      data: { selectedSubBiller: this.siteDetailData?.sub_biller },
    });
    const dialogResp = await firstValueFrom(dialogRef.afterClosed());
    if (!dialogResp) return;
    if (dialogResp == 'remove') {
      this.spinnerService.show('Removing Sub Biller');
      this.updateSiteDetails({}, { change_sub_biller: 1 });
    }
    if (dialogResp?.id) {
      this.spinnerService.show('Changing Sub Biller');
      this.updateSiteDetails(
        { sub_biller_id: dialogResp?.id },
        { change_sub_biller: 1 },
      );
    }
  }
  async openMonitoringCompanyTemplate() {
    const dialogRef = this.dialogService.open(
      SelectMonitoringCompanyComponent,
      {
        data: {
          selectedMonitoringCompany:
            this.siteDetailData?.preferred_monitoring_company,
        },
      },
    );
    const dialogResp = await firstValueFrom(dialogRef.afterClosed());
    if (!dialogResp) return;
    if (dialogResp == 'remove') {
      this.spinnerService.show('Removing Monitoring Company');
      this.updateSiteDetails({}, { change_preferred_monitoring_company: 1 });
    }
    if (dialogResp?.id) {
      this.spinnerService.show('Changing Monitoring Company');
      this.updateSiteDetails(
        { preferred_monitoring_company_id: dialogResp?.id },
        { change_preferred_monitoring_company: 1 },
      );
    }
  }
  updateSiteDetails(body: any, params: any) {
    this.clientService
      .updateSite(this.siteDetailData?.id, body, params)
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSiteData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }
}
